module.exports = __webpack_public_path__ + "static/order-processing-b363acf65c4eac13303a8833b44e518a.gif";